export const EXAMPLE_MUTATION = 'EXAMPLE_MUTATION'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'
export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_MENU = 'SET_MENU'
export const SET_HASLOGIN = 'SET_HASLOGIN'

export const SET_MY_TASKS = 'SET_MY_TASKS'
export const SET_MY_TASKS_STATUS = 'SET_MY_TASKS_STATUS'
export const SET_REPAY_STATISTICS = 'SET_REPAY_STATISTICS'
export const SET_REPAY_STATISTICS_LOGS = 'SET_REPAY_STATISTICS_LOGS'

export const TOTAL_REPAY_AMOUNT = 'TOTAL_REPAY_AMOUNT'
export const SET_TASK_INFO = 'SET_TASK_INFO'
export const SET_CURRENT_LOAN_ITEM = 'SET_CURRENT_LOAN_ITEM'
export const SET_BORROWER_INFO = 'SET_BORROWER_INFO'
export const SET_ITEM_INFO = 'SET_ITEM_INFO'
export const SET_CONTACTS_INFO = 'SET_CONTACTS_INFO'
export const SET_CONTACTS_INFO_LOANS = 'SET_CONTACTS_INFO_LOANS'
export const SET_USER_CONTACTS_INFO = 'SET_USER_CONTACTS_INFO'
export const SET_USER_CALLS_INFO = 'SET_USER_CALLS_INFO'
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS'
export const SET_TASK_LABEL = 'SET_TASK_LABEL'
export const SET_REPORTLIST = 'SET_REPORTLIST'
export const SET_COLLECTION_LOGS = 'SET_COLLECTION_LOGS'
export const SET_COLLECTION_LOGS_TOTAL = 'SET_COLLECTION_LOGS_TOTAL'
export const SET_MERT_CASE_LIST = 'SET_MERT_CASE_LIST'
export const SET_MERT_CASE_LIST_TOTAL = 'SET_MERT_CASE_LIST_TOTAL'
export const SET_CASE_SION_LIST = 'SET_CASE_SION_LIST'
export const SET_CASE_SION_LIST_TOTAL = 'SET_CASE_SION_LIST_TOTAL'
export const SET_SMS_TEMPLATES = 'SET_SMS_TEMPLATES'
export const SET_USER_SMSRECORD = 'SET_USER_SMSRECORD'
export const SET_SMS_LOGS = 'SET_SMS_LOGS'
export const SET_SMS_LOGS_TOTAL = 'SET_SMS_LOGS_TOTAL'

export const SET_MANAGE_QUEUE_LIST = 'SET_MANAGE_QUEUE_LIST'
export const SET_MANAGE_QUEUE_LIST_TOTAL_COUNT = 'SET_MANAGE_QUEUE_LIST_TOTAL_COUNT'
export const SET_MANAGE_BATCH_TASKS_LIST = 'SET_MANAGE_BATCH_TASKS_LIST'
export const SET_MANAGE_BATCH_TASKS_LIST_TOTAL_COUNT = 'SET_MANAGE_BATCH_TASKS_LIST_TOTAL_COUNT'
export const SET_MANAGE_COLLECTION_LOGS_LIST = 'SET_MANAGE_COLLECTION_LOGS_LIST'
export const SET_MANAGE_COLLECTION_LOGS_LIST_TOTAL_COUNT = 'SET_MANAGE_COLLECTION_LOGS_LIST_TOTAL_COUNT'
export const SET_MANAGE_QUEUE_INFO = 'SET_MANAGE_QUEUE_INFO'
export const SET_MANAGE_AUTO_QUEUE = 'SET_MANAGE_AUTO_QUEUE'
export const SET_MANAGE_QUEUE_TASKS_LIST = 'SET_MANAGE_QUEUE_TASKS_LIST'
export const SET_MANAGE_QUEUE_TASKS_LIST_TOTAL_COUNT = 'SET_MANAGE_QUEUE_TASKS_LIST_TOTAL_COUNT'
export const SET_MANAGE_AUTO_QUEUE_LIST_TOTAL_COUNT = 'SET_MANAGE_AUTO_QUEUE_LIST_TOTAL_COUNT'

export const SET_MANAGE_USER_LIST = 'SET_MANAGE_USER_LIST'
export const SET_MANAGE_USER_LIST_TOTAL_COUNT = 'SET_MANAGE_USER_LIST_TOTAL_COUNT'

export const SET_MANAGE_AGENT_INFO = 'SET_MANAGE_AGENT_INFO'

export const SET_QUEUE_AGENTS = 'SET_QUEUE_AGENTS'
